module.exports = __webpack_public_path__ + "487bb1d04bcb2e60d34c57c3eb676161.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_0_0.woff2
// module id = 528
// module chunks = 0